exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".default-menu-item {\n  position: relative;\n  width: 430px;\n  display: block;\n  height: 100vh;\n  overflow: hidden;\n}\ndiv.toast {\n  background: rgba(0, 0, 0, 0.7);\n  position: fixed;\n  z-index: 5000;\n  color: white;\n  left: calc(100px);\n  bottom: 10px;\n  padding: 10px 20px;\n  -webkit-transform: translate(0, 0);\n          transform: translate(0, 0);\n}\ndiv.toast span {\n  cursor: pointer;\n  padding-left: 15px;\n}\ndiv.toast span:hover {\n  color: black;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/src/app/packages/core/components/toast/toast.component.less
// module id = ../../../../../src/app/packages/core/components/toast/toast.component.less
// module chunks = main